import { FC } from 'react'
import { Redirect, Route, RouteProps } from 'react-router'

type Props = RouteProps & { hasPermission: boolean; featureEnabled?: boolean }

export const PermissionRoute: FC<Props> = ({ children, hasPermission, featureEnabled = true, ...rest }) => {
  return (
    <Route
      {...rest}
      render={() => {
        if (hasPermission && featureEnabled) {
          return children
        }
        return <Redirect to={'/'} />
      }}
    />
  )
}
